import React from 'react';
import { WorkspaceItemContext } from '../app/contexts/workspace/workspace-item-context';

export default function useMapInteraction() {
    const context = React.useContext(WorkspaceItemContext);
    return context.interactionService;
}
